<template>
    <div>
        <div class="card shadow bg-white">
            <div class="card-header h6">
                Gestion Super Admin
            </div>

            <div class="p-3 row align-items-center">
                <div class="col-4">
                    <div>Client</div>
                    <p class="text-muted">
                        {{ balise.client ? balise.client.name : 'Non renseigné' }}
                    </p>
                </div>

                <div class="col-4">
                    <div>IMEI</div>
                    <p class="text-muted">
                        <IMEIDisplay :imei="balise.imei" />
                    </p>
                </div>

                <div class="col-4">
                    <div>Code transmetteur Atlant</div>
                    <p class="text-muted">
                        {{ balise.atlantId || 'Non renseigné' }}
                    </p>
                </div>
            </div>

            <div class="p-3 row align-items-center">
                <div class="col-4">
                    <router-link
                        class="mb-0"
                        :to="'/balise/admin/editbalise/' + balise.id"
                    >
                        Modifier la balise
                    </router-link>
                </div>

                <div class="col-4">
                    <router-link
                        class="mb-0"
                        :to="'/balise/admin/alarmtypeconfigs/' + balise.id"
                    >
                        Config alarmes
                    </router-link>
                </div>

                <div class="col-4">
                    <router-link
                        class="mb-0"
                        :to="'/balise/admin/digitalio/' + balise.id"
                    >
                        Config Digital I/O
                    </router-link>
                </div>
            </div>

            <div class="card-footer p-3 text-center">
                Uniquement visible aux admin Argos
            </div>
        </div>
    </div>
</template>

<script>
import IMEIDisplay from '@/components/display/IMEIDisplay.vue'

export default {
    props: ['balise'],
    components: {
        IMEIDisplay,
    },
}
</script>